<template lang="pug">
  b-row
    b-col(sm='12')
      form-wizard(
        @submit.prevent='submit'
        @on-complete='submit()'
        title='Create a new Inspection'
        subtitle='An inspection will be created for each object'
        nextButtonText='Next'
        backButtonText='Prev'
        finishButtonText='Save'
        color='#36a9e1'
        errorColor='#ff5454'
        shape='square'
        )
        //- First Step
        tab-content(
          title='Inspection details'
          icon='icon-settings'
          :before-change='validateFirstStep'
          )
          b-card
            b-row
              b-col(sm='6')
                b-col(sm='12')
                  b-form-fieldset(label='Inspection')
                    b-form-input(
                      type='text',
                      id='checklist_name'
                      name='name'
                      placeholder="Enter inspection's name"
                      v-model='checklist.name'
                      v-validate="'required'"
                    )
                    div.text-danger(v-show="errors.has('name')") {{ errors.first('name') }}
                b-col(sm='12')
                  b-form-fieldset(label='Location')
                    b-form-input(
                      type='text'
                      id='checklist_location'
                      name='location'
                      placeholder='Enter location'
                      v-model='checklist.location'
                    )
                b-col(sm='12')
                  b-form-fieldset(label='Date')
                    b-form-input(
                      type='date'
                      id='checklist_date'
                      name='date'
                      v-model='checklist.date'
                    )
              b-col(sm='6')
                b-col(sm='12')
                  b-form-fieldset(label='Project')
                    multiselect(
                      id='checklist_project'
                      name='project'
                      v-model='currentProject'
                      :options='projectsList'
                      :loading='projectLoading'
                      :internal-search='false'
                      @search-change='asyncFindProjects'
                      label='name'
                      :close-on-select='true'
                      :clear-on-select='true'
                      track-by='id'
                      placeholder='Search a project here'
                      v-validate="'required'"
                    )
                    div.text-danger(v-show="errors.has('project')") {{ errors.first('project') }}
                b-col(sm='12')
                  b-form-fieldset(label='Objects')
                    multiselect(
                      id='checklist_structures'
                      name='structures'
                      v-model='currentStructures'
                      :multiple='isMultiple'
                      :options='structuresList'
                      :loading='structuresLoading'
                      :internal-search='true'
                      label='card_name'
                      :close-on-select='true'
                      track-by='id'
                      placeholder='Search objects here'
                      v-validate="'required'"
                    )
                    div.text-danger(v-show="errors.has('structures')") {{ errors.first('structures') }}

        //- Second Step
        tab-content(
          title='To do'
          icon='icon-equalizer'
          )
          template(v-for='(item, index) in checklist.checklist_items')
            b-card
              b-row
                b-col(sm='6')
                  b-form-fieldset(label='Part')
                    b-form-input(
                      type='text',
                      id='checklist_item_part' + index
                      name='part' + index
                      placeholder="Enter inspection-item's part"
                      v-model='item.name'
                    )
                b-col(sm='5')
                  b-form-fieldset(label='ID')
                    b-form-input(
                      type='text',
                      id='checklist_item_component_name' + index
                      name='component_name' + index
                      placeholder="Enter component's ID"
                      v-model='item.component_name'
                    )
                b-col(sm='1')
                  a(@click='removeChecklistItem(index)')
                    i.fa.fa-minus-square-o.fa-lg.form__minus_btn.text-danger
          b-col.py-4.text-center(sm='12')
            button.btn.btn-primary.px-4(@click='addChecklistItem')
              i.fa.fa-angle-double-down.fa-lg.px-2
              span Add inspection-item
              i.fa.fa-angle-double-down.fa-lg.px-2
        //- Third Step
        tab-content(
          title='Summary and confirmation'
          icon='icon-check'
          )
          b-card-group(deck)
            b-card
              b-col(sm='12')
                h3 Inspection
                p
                  span.font-weight-bold.pr-2 Inspection:
                  span {{checklist.name}}
                p
                  span.font-weight-bold.pr-2 Location:
                  span {{checklist.location}}
                p
                  span.font-weight-bold.pr-2 Date:
                  span {{checklist.date}}
                p
                  span.font-weight-bold.pr-2 Project:
                  span {{currentProject.name}}
                p
                  span.font-weight-bold.pr-2 Objects:
                  ul
                    li(v-for='structure in currentStructures') {{structure.card_name}}

            b-card
              b-col(sm='12')
                h3 Inspection-Items
                template(v-for='(item, index) in checklist.checklist_items')
                  p.mb-0
                    span.font-weight-bold.pr-2 {{index+1}}. Part:
                    span {{item.name}}
                  p.mb-3
                    span.font-weight-bold.px-3 Component ID:
                    span {{item.component_name}}
</template>

<script>
  import server from '@/server'
  import Messages from '@/utils/notificationsMsg'
  import Multiselect from 'vue-multiselect'
  import _ from 'lodash'
  import RouteGen from '@/utils/apiRoutes'

  import { FormWizard, TabContent } from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'

  export default {
    name: 'ChecklistNew',
    components: { Multiselect, FormWizard, TabContent },
    data () {
      return {
        projectLoading: false,
        structuresLoading: false,
        isMultiple: true,
        projectsList: [],
        structuresList: [],
        currentProject: '',
        currentStructures: [],
        checklist: {
          name: '',
          location: '',
          date: '',
          batch_code: '',
          project_id: '',
          structure_ids: [],
          checklist_items: [
            {
              name: '',
              component_name: ''
            }
          ]
        }
      }
    },
    props: {
      stepSize: {
        type: String,
        default: 'md',
        validator: (value) => {
          let acceptedValues = ['xs', 'sm', 'md', 'lg']
          return acceptedValues.indexOf(value) !== -1
        }
      }
    },
    watch: {
      currentProject: function (val, oldVal) {
        this.$set(this.$data, 'currentStructures', val.project_structures.map((obj) => { return obj.structure }))
        this.$set(this.$data, 'structuresList', val.project_structures.map((obj) => { return obj.structure }))
      }
    },
    methods: {
      getStructureIds (structures) {
        return structures.map((structure) => { return structure.id })
      },
      asyncFindProjects: _.debounce(
        function (query) {
          this.projectLoading = true
          let url = RouteGen.index('project')
          server.get(url, {
            params: {
              'q[name_cont]': query
            }
          })
          .then(res => {
            this.$set(this.$data, 'projectsList', res.data.projects)
            this.projectLoading = false
          })
          .catch(err => {
            console.log(err)
            this.projectLoading = false
          })
        },
        700
      ),
      addChecklistItem () {
        this.checklist.checklist_items.push({
          name: '',
          component_name: ''
        })
      },
      removeChecklistItem (index) {
        this.checklist.checklist_items.splice(index, 1)
      },
      validateFirstStep () {
        return this.$validator.validateAll()
      },
      submit () {
        if (!this.validateFirstStep) { this.errFirstStep() }
        this.saveChecklist(this.$route.params.id)
      },
      saveChecklist (id = null) {
        let url = 'checklists/batch' // custom route, not use RouteGen
        let verb = 'post'
        let messageModifier = 'created'
        this.$data.checklist.project_id = this.$data.currentProject.id
        this.$data.checklist.structure_ids = this.getStructureIds(this.$data.currentStructures)
        server[verb](url, { checklist: this.$data.checklist })
          .then(res => {
            this.showNotification(201, messageModifier)
            this.$router.push({ name: 'All inspections' })
          })
          .catch(err => {
            this.showNotification(err.response.status)
          })
      },
      showNotification (status, modifier) {
        return this.getMessage(Messages.byStatus(status, 'Inspection', modifier))
      }
    },
    notifications: {
      getMessage: {},
      errFirstStep: {
        title: 'Inspection details',
        message: 'Incorrect informations',
        type: 'error'
      },
      errSecondStep: {
        title: 'To Do',
        message: 'Incorrect informations',
        type: 'error'
      }
    }
  }
</script>

<style lang="sass">
  .form__minus_btn
    font-size: 1.65rem
    cursor: pointer
    top: 50%
    position: relative
</style>



// WEBPACK FOOTER //
// src/components/Checklist/New.vue